export const posiblePasswords = {
    siiApoderado: "siiApoderado",
    sii: "sii",
    transbank: "transbank",
    previred: "previred",
    clayApiToken: "clayApiToken",
    bsaleApiToken: "bsaleApiToken",
    talana: "talana",
    santander: "santander",
    bankEstado: "bankEstado",
    bankBICE: "bankBICE",
    bankItau: "bankItau",
    bankChile2: "bankChile2",
    security: "security",
    bci: "bci",
    consorcio: "consorcio",
    scotiabank: "scotiabank",
    bankInternational: "bankInternational",
    buk: "buk",
    buk_editor: "buk_editor"
    //emailPassword: "emailPassword",
    //rutRutPassword: "rutRutPassword",
    //usernamePassword: "usernamePassword",
    //companyUser: "companyUser",
}